const getProductType = (SKUCategory: string, matchingThankYouPageInfo: any) => {
  if (!!matchingThankYouPageInfo && matchingThankYouPageInfo?.customProductType) {
    return matchingThankYouPageInfo?.customProductType;
  }

  return SKUCategory;
};

export default getProductType;
